package presentation.screens.business.inventory.product.create

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import component.button.DefaultButton
import component.button.SecondaryButton
import component.loader.AppLoader
import component.navigation.TopNavBar
import component.stepper.StepsProgressBar
import feature.alert.handler.AlertHandler
import feature.product.model.Product
import feature.product.viewModel.ProductViewModel
import locale.localization
import presentation.screens.business.inventory.product.create.component.CreateProductBasicInfo
import presentation.screens.business.inventory.product.create.component.CreateProductMoreInfo
import presentation.screens.business.inventory.product.create.component.CreateProductPricing
import presentation.screens.business.inventory.product.create.component.CreateProductTax
import theme.ThemeColor

class CreateProductScreen : Screen {


    @Composable
    override fun Content() {
        val totalSteps = 3
        val viewModel = ProductViewModel()
        val currentStep = viewModel.productFormIndex.collectAsState()
        val navigator = LocalNavigator.current
        LaunchedEffect(key1 = Unit) {
//            viewModel.setNewProduct(Product())
        }
        fun onClickSave() {
            viewModel.createProduct {
                if (it) {
                    viewModel.setProductFormIndex(0)
                    viewModel.setNewProduct(Product())
                    navigator?.pop()
                } else {
                    AlertHandler.shared().showAlert(localization().productMenu.productsAlertTitle,
                        localization().productMenu.productsAlertMessage/*"Oops!", "Something went wrong"*/)
                }
            }
        }
        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(title = localization().productMenu.productsCreateNew, onBackPress = {
                if (currentStep.value == 0) {
                    navigator?.pop()
                } else {
                    viewModel.setProductFormIndex(currentStep.value - 1)
                }
            })
            AppLoader(viewModel)
            Box(
                modifier = Modifier.fillMaxWidth().height(40.dp).background(
                    ThemeColor.shared().cardBackground,
                    RoundedCornerShape(8.dp)
                ).padding(8.dp)
            ) {
                StepsProgressBar(
                    modifier = Modifier.fillMaxWidth(),
                    numberOfSteps = totalSteps,
                    currentStep = currentStep.value
                )
            }
            if (currentStep.value == 0) {
                CreateProductBasicInfo(viewModel)
            } else if (currentStep.value == 1) {
                CreateProductPricing(viewModel)
            } else if (currentStep.value == 2) {
                CreateProductTax(viewModel)
            } else if (currentStep.value == 3) {
                CreateProductMoreInfo(viewModel)
            }
            Row {
                if (currentStep.value > 0) {
                    Box(modifier = Modifier.fillMaxHeight().width(140.dp)) {
                        DefaultButton(if (currentStep.value == 2) /*"Prev" else "Prev"*/ localization().productMenu.productsPrevButton else localization().productMenu.productsPrevButton, onClick = {
                            viewModel.setProductFormIndex(currentStep.value - 1)
                        })
                    }
                }
                Box(modifier = Modifier.fillMaxHeight().width(140.dp)) {
                    SecondaryButton(if (currentStep.value == 2) /*"Save" else "Save"*/ localization().productMenu.productsSaveButton else localization().productMenu.productsSaveButton, onClick = {
                        onClickSave()
                    })
                }
                if (currentStep.value < totalSteps) {
                    DefaultButton(localization().productMenu.productsNextButton/*"Next"*/, onClick = {
                        viewModel.setProductFormIndex(currentStep.value + 1)
                    })
                }
            }
        }
    }
}